import React from 'react'
import moment from 'moment'
import { TYPE_CHAT_TELEGRAM, TYPE_CHAT_VIBER, TYPE_CHAT_VK } from './constant'

/**
 * Generate link to chatbot.
 * @param messengerType Type messenger as string number.
 * @param chatbotName Valid name of chatbot, from selected messenger.
 */
export function generateChatbotUrl(messengerType, chatbotName) {
  const intMessengerType = Number(messengerType)
  let url
  switch (intMessengerType) {
    case TYPE_CHAT_VIBER:
      url = `viber://pa?chatURI=${chatbotName}`
      break
    case TYPE_CHAT_VK:
      url = `vk.me/public${chatbotName}`
      break
    case TYPE_CHAT_TELEGRAM:
      url = `https://t.me/${chatbotName}`
      break
    default:
      url = ''
      break
  }
  return url
}

/**
 *
 * @param errors
 * @constructor
 */
export function ValidationError(errors) {
  Error.call(this, errors)
  this.name = 'ValidationError'

  this.errors = errors
  this.message = 'Error validation'
  this.status = 422

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, ValidationError)
  } else {
    this.stack = new Error().stack
  }
}

/**
 *
 * @type {Error}
 */
ValidationError.prototype = Object.create(Error.prototype)

/**
 *
 * @param constants
 * @returns {*}
 */
export function createConstants(...constants) {
  return constants.reduce((acc, constant) => {
    acc[constant] = constant
    return acc
  }, {})
}

/**
 *
 * @param initialState
 * @param reducerMap
 * @returns {function(*=, *)}
 */
export function createReducer(initialState, reducerMap) {
  return (state = initialState, action) => {
    const reducer = reducerMap[action.type]

    return reducer ? reducer(state, action.payload) : state
  }
}

/**
 *
 * @param response
 * @returns {*}
 */
export function checkHttpStatus(response) {
  // if success status
  if (response.status.error === 0) {
    return response
  }
  if (response.status === 422) {
    throw new ValidationError(response.data)
  }

  // TODO: so bad code?
  if (response.status.message === 'Нет такой сессии') {
    localStorage.removeItem('sessionId')
    console.log(response.status.message)
    window.location.replace(`/login`)
  }

  throw new Error(response.status.message)
}

/**
 *
 * @param response
 * @returns {*}
 */
export function parseJSON(response) {
  return response.json()
}

/**
 *
 * @param key
 * @returns {string}
 */
function camelToUnderscore(key) {
  return key.replace(/([A-Z])/g, '_$1').toLowerCase()
}

/**
 *
 * @param key
 */
function underscoreToCamel(key) {
  return key.replace(/_([a-z])/g, (m, w) => w.toUpperCase())
}

/**
 *
 * @param errors
 * @param toCamelCase
 * @returns {{}}
 */
export function getFormErrors(errors = [], toCamelCase = true) {
  const formErrors = {}
  errors.map((err) => {
    const name = toCamelCase ? underscoreToCamel(err.field) : err.field
    formErrors[name] = err.message
  })

  return formErrors
}

export function createActualShowTime(time, format) {
  const timeOffset = localStorage.getItem('timeOffset') || 0

  time = moment(time, format).add(timeOffset, 'hours').format(format)

  return time
}

export function createActualSendTime(time, format) {
  const timeOffset = localStorage.getItem('timeOffset') || 0

  const newOffset = Number(timeOffset) * -1

  time = moment(time, format).add(newOffset, 'hours').format(format)

  return time
}

export function getWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth,
  )
}



// WEBPACK FOOTER //
// src/shared/utils/index.js